import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { ProductIntroComponent, StarRatingModule } from '@spartacus/storefront';
import { GenAddToFavoritesComponent } from '../../favorites/add-to-favorites/add-to-favorites.component';

@Component({
    selector: 'gen-product-intro',
    templateUrl: './product-intro.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, I18nModule, StarRatingModule, GenAddToFavoritesComponent],
})
export class GenProductIntroComponent extends ProductIntroComponent { }
